import BaseClass from "../../util/BaseClass";
import Context from "../../context/Context";
import Categories from "./Categories";
import CIMCategories from "./CIMCategories";
import Details from "./Details";
import Events from "./Events";
import Facilities from "./Facilities";
import IndoorsConfig from "./IndoorsConfig";
import Landmarks from "./Landmarks";
import Levels from "./Levels";
import Pathways from "./Pathways";
import People from "./People";
import Sections from "./Sections";
import Sites from "./Sites";
import Transitions from "./Transitions";
import Units from "./Units";
import Zones from "./Zones";
import * as aiimUtil from "../util/aiimUtil";

export default class Datasets extends BaseClass {

  categories;
  cimCategories;
  indoorsConfig;
  details;
  events;
  facilities;
  landmarks;
  levels;
  pathways;
  people;
  sections;
  sites;
  transitions;
  units;
  zones;

  _categoriesUrl;
  _datasets = [];
  _indoorsConfigUrl;

  _checkSchemas() {
    const promises = [];
    this._datasets.forEach(dataset => {
      const p = dataset.checkSchema();
      if (p) promises.push(p);
    });
    if (promises.length > 0) {
      const lib = Context.getInstance().lib;
      // TODO use Promise.all?
      return lib.esri.promiseUtils.eachAlways(promises).then((results) => {
        //console.log("datasets =.=.=.=.=.=",this); // TODO temporary
      });
    } else {
      return Promise.resolve();
    }
  }

  isPeopleLayer(layer,fields) {
    if (this.people) return this.people.isPeopleLayer(layer,fields);
    return false;
  }

  load() {
    const mapView = Context.getInstance().views.mapView;
    const sceneView = Context.getInstance().views.sceneView;
    const promise = this._waitForMapService(mapView).then(() => {
      //return aiimUtil.waitForLayers(mapView);
    }).then(() => {
      //return aiimUtil.waitForLayers(sceneView);
    }).then(() => {
      this._processMapView(mapView);
      this._processSceneView(sceneView);
    }).then(() => {
      return this._loadIndoorsConfig();
    }).then(() => {
      return this._checkSchemas();
    }).then(() => {
      this.cimCategories = new CIMCategories();
      return this.cimCategories.load();
    }).then(() => {
      return this._loadCategories();
    });
    return promise;
  }

  _loadIndoorsConfig() {
    this.indoorsConfig = new IndoorsConfig();
    return this.indoorsConfig.load(this._indoorsConfigUrl);
  }

  _loadCategories() {
    this.categories = new Categories();
    return this.categories.load(this._categoriesUrl,this.cimCategories);
  }

  _processMapView(view) {
    if (!view) return;
    const layers = aiimUtil.getLayers(view);
    layers.forEach(layer => {

      // TODO need a better foreign key than layer.title
      if (layer.title === "Details") {
        if (!this.details) this.details = new Details();
        this._datasets.push(this.details);
        this._setDatasetLayer(this.details,view,layer);
      } else if (layer.title === "Events") {
        if (!this.events) this.events = new Events();
        this._datasets.push(this.events);
        this._setDatasetLayer(this.events,view,layer);
      } else if (layer.title === "Facilities") {
        if (!this.facilities) this.facilities = new Facilities();
        this._datasets.push(this.facilities);
        this._setDatasetLayer(this.facilities,view,layer);
      } else if (layer.title === "Landmarks") {
        if (!this.landmarks) this.landmarks = new Landmarks();
        this._datasets.push(this.landmarks);
        this._setDatasetLayer(this.landmarks,view,layer);
      } else if (layer.title === "Levels") {
        if (!this.levels) this.levels = new Levels();
        this._datasets.push(this.levels);
        this._setDatasetLayer(this.levels,view,layer);
      } else if (layer.title === "Pathways") {
        if (!this.pathways) this.pathways = new Pathways();
        this._datasets.push(this.pathways);
        this._setDatasetLayer(this.pathways,view,layer);
      } else if (layer.title === "People") {
        if (!this.people) this.people = new People();
        this._datasets.push(this.people);
        this._setDatasetLayer(this.people,view,layer);
      } else if (layer.title === "Sections") {
        if (!this.sections) this.sections = new Sections();
        this._datasets.push(this.sections);
        this._setDatasetLayer(this.sections,view,layer);
      } else if (layer.title === "Sites") {
        if (!this.sites) this.sites = new Sites();
        this._datasets.push(this.sites);
        this._setDatasetLayer(this.sites,view,layer);
      } else if (layer.title === "Transitions") {
        if (!this.transitions) this.transitions = new Transitions();
        this._datasets.push(this.transitions);
        this._setDatasetLayer(this.transitions,view,layer);
      } else if (layer.title === "Units") {
        if (!this.units) this.units = new Units();
        this._datasets.push(this.units);
        this._setDatasetLayer(this.units,view,layer);
      } else if (layer.title === "Zones") {
        if (!this.zones) this.zones = new Zones();
        this._datasets.push(this.zones);
        this._setDatasetLayer(this.zones,view,layer);
      }
    });

    const tables = view.map.tables;
    if (tables && tables.length > 0) {
      tables.forEach(table => {
        let uc = "";
        if (typeof table.title === "string") uc = table.title.toUpperCase();
        if (uc === "CATEGORIES") {
          // console.log("CATEGORIES",table.title,table);
          this._categoriesUrl = table.url;
        } else if (uc === "INDOORS CONFIGURATION" || uc === "INDOORSCONFIG") {
          this._indoorsConfigUrl = table.url;
          //console.log("INDOORSCONFIG",table.title);
          // network service url?
        } else if (uc === "EMPLOYEEINFO") {
          //console.log("EMPLOYEEINFO",table.title);
        } else if (uc === "DISPLAYLODS") {
          //console.log("DISPLAYLODS",table.title);
        } else if (uc === "DISPLAYSCALES") {
          //console.log("DISPLAYSCALES",table.title);
        }
      });
    }

    if (this.facilities) {
      let found = false, aboveFacilities = false;
      layers.forEach(layer => {
        if (layer === this.facilities.layer2D || layer === this.facilities.subLayer) {
          found = true;
        }
        if (aboveFacilities) {
          layer.xtnAboveFacilities = true;
        }
        if (found) aboveFacilities = true;
        //console.log(layer.title,layer.xtnAboveFacilities);
      });
    }

  }

  _processSceneView(view) {
    if (!view) return;
    const layers = aiimUtil.getLayers(view);
    layers.forEach(layer => {

      // TODO need a better foreign key than layer.title
      if (layer.title === "Details") {
        this._setDatasetLayer(this.details,view,layer);
      } else if (layer.title === "Events") {
        this._setDatasetLayer(this.events,view,layer);
      } else if (layer.title === "Facilities" || layer.title === "Facilities Textured") {
        this._setDatasetLayer(this.facilities,view,layer);
      } else if (layer.title === "Landmarks") {
        this._setDatasetLayer(this.landmarks,view,layer);
      } else if (layer.title === "Levels") {
        this._setDatasetLayer(this.levels,view,layer);
      } else if (layer.title === "Pathways") {
        this._setDatasetLayer(this.pathways,view,layer);
      } else if (layer.title === "People") {
        this._setDatasetLayer(this.people,view,layer);
      } else if (layer.title === "Sections") {
        this._setDatasetLayer(this.sections,view,layer);
      } else if (layer.title === "Sites") {
        this._setDatasetLayer(this.sites,view,layer);
      } else if (layer.title === "Transitions") {
        this._setDatasetLayer(this.transitions,view,layer);
      } else if (layer.title === "Units" || layer.title === "Units3D") {
        this._setDatasetLayer(this.units,view,layer);
      } else if (layer.title === "Zones") {
        this._setDatasetLayer(this.zones,view,layer);
      }
    });
  }

  _setDatasetLayer(dataset, view, layer) {
    if (!dataset) return;
    layer.xtnAiim = {
      dataset: dataset
    };
    if (view.type === "2d") {
      if (layer && layer.declaredClass === "esri.layers.support.Sublayer") {
        let layer2D = layer.xtnFeatureLayer;
        if (!layer2D) {
          layer2D = layer.createFeatureLayer();
          layer2D.load();
        }
        dataset.subLayer = layer;
        dataset.url = layer.url
        dataset.layer2D = layer2D;
        dataset.layer2D.xtnAiim = layer.xtnAiim;
      } else {
        dataset.url = layer.url+"/"+layer.layerId;
        dataset.layer2D = layer;
      }
    } else if (view.type === "3d") {
      dataset.layer3D = layer;
    }
  }

  _waitForMapService(view) {
    const lib = Context.getInstance().lib;
    const promise = new Promise((resolve,reject) => {
      const promises = [], promises2 = [];
      if (view && view.type === "2d") {
        view.map.layers.forEach((layer: any) => {
          if (layer.type === "map-image") {
            if (typeof layer.when === "function") {
              promises.push(layer.when().then());
            }
          }
        });
      }
      if (promises.length > 0) {
        lib.esri.promiseUtils.eachAlways(promises).then(results => {
          //console.log("waitForMapService =.=.=.=.=.=",results); // TODO temporary
          const layers = aiimUtil.getLayers(view);
          layers.forEach((layer) => {
            if (layer && layer.declaredClass === "esri.layers.support.Sublayer" &&
                !layer.xtnFeatureLayer) {
              let promise2 = layer.createFeatureLayer();
              promise2.then(featureLayer => {
                //console.log("FeatureLayer",featureLayer);
                try {
                  layer.xtnFeatureLayer = featureLayer;
                  featureLayer.xtnSubLayer = layer;
                  featureLayer.load();
                } catch(exload) {
                  console.warn("Error loading FeatureLayer",featureLayer,"for Sublayer",layer);
                  console.error(exload);
                }
              });
              promises2.push(promise2);
            }
          });

          if (promises2.length > 0) {
            lib.esri.promiseUtils.eachAlways(promises2).then(results2 => {

              // Issue #1077 , must be a JSAPI 4.10 issue, map service layers are set to visible by default
              try {
                layers.forEach(layer => {
                  //console.log(layer.title,layer.declaredClass,layer);
                  if (layer && layer.declaredClass === "esri.layers.support.Sublayer") {
                    if (layer.visible && layer.xtnFeatureLayer) {
                      let lyr = layer.xtnFeatureLayer;
                      lyr.when(() => {
                        //if (lyr.source && lyr.source.layerDefinition) {
                        if (lyr.sourceJSON) {
                          //let defaultVisibility = lyr.source.layerDefinition.defaultVisibility;
                          let defaultVisibility = lyr.sourceJSON.defaultVisibility;
                          if (typeof defaultVisibility === "boolean") {
                            if (layer.visible && !defaultVisibility) {
                              console.log("Resetting defaultVisibility for",layer.title);
                              layer.visible = false;
                            }
                          }
                        }
                      })
                    }
                  }
                });
              } catch(ex2) {
                console.log("Error restoring defaultVisibility",ex2);
              }

              resolve();
            }).catch(ex2 => {
              reject(ex2);
            });
          } else {
            resolve();
          }
        }).catch(ex => {
          reject(ex);
        });
      } else {
        resolve();
      }
    });
    return promise;
  }

}
